import { Link, createFileRoute } from "@tanstack/react-router";
import { type FormEvent, useState } from "react";

import { authApi } from "../lib/api";

export const Route = createFileRoute("/forgot-password")({ component: ForgotPasswordPage });

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await authApi.requestPasswordReset(email);
    setSent(true);
  };
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-5 rounded-2xl border border-[var(--border)] bg-[var(--surface)] p-6 shadow-sm"
      >
        <header>
          <h1 className="text-2xl font-semibold">Reset your password</h1>
          <p className="text-sm opacity-60">We will email a single-use reset link.</p>
        </header>
        {!sent ? (
          <>
            <label className="block text-sm">
              <span className="mb-1 block">Email</span>
              <input
                className="form-input w-full"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <button
              type="submit"
              className="min-h-11 w-full rounded-md bg-[var(--accent)] px-4 py-2 text-sm font-medium text-white"
            >
              Send reset link
            </button>
          </>
        ) : (
          <div className="rounded-md border border-[var(--border)] p-3 text-sm">
            If that address is registered, the reset email is on its way.
          </div>
        )}
        <Link to="/login" className="block text-center text-sm text-[var(--accent)]">
          Back to sign in
        </Link>
      </form>
    </div>
  );
}
